<template>
  <div class="learn-ability-test-share-hint-component">
    <ym-popup class="learn-ability-test-share-hint-popup"
              v-model="visible"
              overlay-background="rgba(34, 34, 34, .75)"
    >
      <div class="learn-ability-test-share-hint-content">
        点击右上角【...】<br />
        分享“自主学习力测试”给好友
      </div>
    </ym-popup>
  </div>
</template>

<script>
  import { Popup } from '@ymba/ym-ui';

  export default {
    name: 'LearnAbilityTestShareHint',
    components: {
      'ym-popup': Popup,
    },
    props: {
      show: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        visible: false,
      };
    },
    watch: {
      show(val) {
        this.visible = val;
      },
      visible(val) {
        this.$emit('update:show', val);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .learn-ability-test-share-hint {
    &-popup {
      box-sizing: border-box;
      width: 642px;
      height: 354px;
      padding: 199px 60px 0;
      top: 62px;
      font-size: 28px;
      color: #fff;
      text-align: center;
      transform: translate3d(-50%, 0, 0);
      background: url('~@/pages/2020/WorldReadingDay/assets/img/prize_draw_share_hint_bg.png') no-repeat;
      background-size: contain;
    }
  }
</style>
